module.exports = __webpack_public_path__ + "static/img/job_2.b099eb9e.png";